// This file was automatically generated from uiwidget.multilist.html.
// Please don't edit this file by hand.

goog.provide('el8.template.uiwidget.multilist');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.appshared.imo');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.multilist.entry = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="ml-entry" _ml_index="', soy.$$escapeHtml(opt_data.index), '"><span class="ml-remove"><a class="ml-remove-trigger"></a></span><label class="el8label ml-label', (opt_data.isSortable) ? ' ml-sort' : '', '">', (opt_data.isNumbered) ? '<span class="ml-label-number el8Bold">' + soy.$$escapeHtml(opt_data.index + 1) + ':</span>' : '-', '</label><div class="ml-container"><ol class="ml-list"><li class="le-entry el8ItemHover"><div class="ml-parent"><textarea class="ml-parentedit el8Bold"></textarea><span class="ml-parentdisplay el8Bold"></span></div></li>', (opt_data.hasAnnotations) ? '<li class="ml-annotation"></li>' : '', '</ol></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.multilist.trigger = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<a class="ml-trigger" name="', soy.$$escapeHtml(opt_data.triggerName), '">', soy.$$escapeHtml(opt_data.triggerName), '</a>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.multilist.imoAnnotation = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.imos && opt_data.imos.length) {
    output.append('<div class="el8CodeSmaller">');
    el8.template.appshared.imo.imoList({imos: opt_data.imos, icd10Only: true}, output);
    output.append('</div>');
  }
  if (!opt_sb) return output.toString();
};
